import jwtDecode from 'jwt-decode';
import Cookies from 'js-cookie';
import { axiosInstance } from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  // ----------------------------------------------------------------------

  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

const setSession = (accessToken, refreshToken) => {
  if (accessToken) {
    Cookies.set('accessToken', accessToken, { secure: true });
    Cookies.set('refreshToken', refreshToken, { secure: true });
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    Cookies.remove('accessToken');
    delete axiosInstance.defaults.headers.common.Authorization;
  }

  if (refreshToken) {
    Cookies.set('refreshToken', refreshToken, { secure: true });
  } else {
    Cookies.remove('refreshToken');
    delete axiosInstance.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession };
